export function filteringDropDown() {
  $('.js-listing-filter, .js-booking-filter, .js-review-filter').parent().find('.custom-select__list li').on('click', function () {
    $(this).closest('form').submit();
  });
}
